import type {ReactNode} from "react";

import useHelpIndex from "../hooks/use-help-index";

type HelpProviderProps = {
  children: ReactNode;
};

/** Warms help index cache after login; screens fetch their own field bundles. */
export function HelpProvider({children}: HelpProviderProps) {
  useHelpIndex();
  return children;
}
